<template>
  <Appendix
    title="Phụ lục cho mượn"
    :fields="fieldsTable"
    :actions="actions"
    :excepts="excepts"
    :only="only"
    :items="items"
    :contract="contract"
  >
    <template #row-details="item">
      <div v-if="item.signType">
        Hình thức ký:
        {{
          item.signType === 'SIGN_ECONTRACT'
            ? 'Ký điện tử'
            : item.signType === 'SIGN_PCONTRACT'
              ? 'Ký giấy'
              : ''
        }}
      </div>
      <DeviceInfoAppendix :items="item.appendixLend.deviceInfos">
        Tiền cọc: {{ item.appendixLend.deposit | fomatCurrency }}
      </DeviceInfoAppendix>
      <template v-if="item.statusHandover"
        >Trạng thái xác nhận bàn giao:
        <Status :value="item.statusHandover" :config="Config.statusHandoverList"
      /></template>
      <StoreInfoAppendix :fields="storeTable" :items="item.merchantBusinessAreas" />
    </template>
    <template #file="item">
      <div v-if="item.urlPDF" class="form-detail">
        <UploadMultiple
          :lsData="[item]"
          keyUrl="urlPDF"
          :canUpload="false"
          :title="`File phụ lục ${item.code}`"
          titleTag="h1"
          titleClass="form-inner-heading"
        />
        <div v-if="item.files?.length" class="form-detail">
          <UploadMultiple
            :lsData="item.files"
            keyUrl="urlPDF"
            :canUpload="false"
            title="File xác nhận bàn giao"
            titleTag="h1"
            titleClass="form-inner-heading"
          />
        </div>
      </div>
    </template>
  </Appendix>
</template>

<script>
  import Appendix from './Appendix.vue'
  import DeviceInfoAppendix from './DeviceInfoAppendix.vue'
  import UploadMultiple from '@/components/UploadMultiple.vue'
  import StoreInfoAppendix from './StoreInfoAppendix.vue'
  export default {
    props: {
      actions: {
        type: Function,
      },
      excepts: {
        type: Array,
        default: () => [],
      },
      only: {
        type: Array,
        default: () => [],
      },
      items: {
        type: Array,
        default: () => [],
      },
      contract: {
        type: Object,
        default: () => {},
      },
    },
    components: { Appendix, DeviceInfoAppendix, UploadMultiple, StoreInfoAppendix },
    data() {
      return {
        fieldsTable: [
          { key: 'code', label: 'Số phụ lục', class: 'text-left' },
          {
            key: 'time',
            label: 'Thời gian',
            class: 'text-left',
            thStyle: 'min-width: 210px',
          },
          { key: 'numDevices', label: 'SL thiết bị', class: 'text-right' },
          {
            key: 'price',
            label: 'Thành tiền',
            class: 'text-right',
            formatter: value => this.$options.filters.fomatCurrency(value),
          },
          { key: 'state', label: 'Trạng thái', class: 'text-center' },
          { key: 'type', label: 'Hình thức mua TB', class: 'text-center' },
          { key: 'action', label: 'Thao tác', class: 'text-center' },
        ],
        storeTable: [
          { key: 'areaName', label: 'Tên' },
          { key: 'typeStore', label: 'Loại cửa hàng' },
          { key: 'areaAddress', label: 'Địa chỉ' },
          { key: 'areaUrl', label: 'Ảnh cửa hàng', class: 'text-center' },
        ],
      }
    },
  }
</script>

<style scoped></style>
